import createNotification from './createNotification';
import utility from './utility';

const accountSpendLimit = {
    init: function() {
        const editSpendLimitButton = document.querySelector("#account--spend-limit-edit");
        if (editSpendLimitButton) {
            editSpendLimitButton.onclick = () => {
                this.showAccountSpendLimitPopup();
            };
        }

        const spendLimitForm = document.querySelector("#account--spend-limit-form");
        if (spendLimitForm) {
            spendLimitForm.onsubmit = () => {
                this.requestUpdateAccountSpendLimit();
                return false;
            };
            spendLimitForm.querySelector("input[name='amount']").onkeydown = (e) => utility.validateNumber(e);
        }
    },

    showAccountSpendLimitPopup: function() {
        const form = document.getElementById("account--spend-limit-form");
        if (form) {
            form.querySelector("input[name='amount']").value = "";
            utility.removeFormInputErrors(form);
            var errorNode = form.querySelector(".input-error");
            if (errorNode) {
                errorNode.style.display = "none";
            }
        }
        utility.showPopup(document.getElementById("account--spend-limit-popup"));
    },

    requestUpdateAccountSpendLimit: function() {
        const ajaxOptions = {
            url: "/api/web/account/update-spend-limit",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--spend-limit-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#account--spend-limit-form");
                utility.removeFormInputErrors(form);
                if (result.success) {
                    document.getElementById("account--spend-limit-page-title").innerText = result.newAmount;
                    document.getElementById("account--spend-limit-popup-title").innerText = result.newAmount;
                    document.getElementById("account--spend-limit-remaining").innerText = result.remaining;
                    utility.hidePopups();
                    createNotification("Your weekly spend limit has been updated");
                }
                else if (result.fieldError.Name) {
                    var errorNode = form.querySelector(".input-error");
                    if (errorNode) {
                        errorNode.style.display = "";
                        errorNode.textContent = result.fieldError.Error;
                    }
                    utility.addFormInputError(form, result.fieldError.Name, result.fieldError.Error);
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.fieldError.Error
                    });
                }
            },
            always: function() {
                utility.enableButton(document.querySelector("#account--spend-limit-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--spend-limit-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    }
};

export default accountSpendLimit;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountSpendLimit.js